

export const convertTopMeteo = (data, unit) => {
    // unit is metric (m) or imperial (ft)
    if (unit === 'm') {
        return {
            clouds_high: data.clouds_high,
            clouds_midlevel: data.clouds_midlevel,
            cumulus: data.cumulus,
            pfd: data.pfd,
            pfd_unit: 'km',
            temp_2m: data.temp_2m,
            temp_2m_unit: 'ºC',
            thermal: data.thermal,
            thermal_unit: 'm/s',
            weather: data.weather,
            wind_10_ang: data.wind_10_ang,
            // convert from kt to kmph
            wind_10_mag: Math.round(data.wind_10_mag * 1.852),
            wind_10_mag_unit: 'km/h',
        }
    } else {
        return {
            clouds_high: data.clouds_high,
            clouds_midlevel: data.clouds_midlevel,
            cumulus: data.cumulus,
            pfd: data.pfd,
            pfd_unit: 'km',
            temp_2m: data.temp_2m,
            temp_2m_unit: 'ºC',
            thermal: Math.round(data.thermal * 1.94384), // convert m/s to knots
            thermal_unit: 'kn',
            weather: data.weather,
            wind_10_ang: data.wind_10_ang,
            wind_10_mag: data.wind_10_mag,
            wind_10_mag_unit: 'kt',
        }
    }
}